import React from 'react'
import { FaIcon, shieldCheckSolid } from '@assets/icons'

function CheckmarkMiddleLogo() {
  return <FaIcon icon={shieldCheckSolid} style={{ fontSize: '22px' }} />
}

export default CheckmarkMiddleLogo
